import * as React from 'react';
import {FormComponentProps} from "antd/lib/form";
import {Form} from "antd";
import * as moment from 'moment';
import locales from "../locales";
import SubmitCancelFormItem from "../common/form-items/SubmitCancelFormItem";
import DatePickerFormItem from "../common/form-items/DatePickerFormItem";
import {MOMENT_DATE_FORMAT} from "../utils/date-utils";

const FIELD_PAID_DATE = 'paidDate';

interface Props extends FormComponentProps {
  onFormSubmit: (paidDate: string) => void;
  onFormCancel: () => void;
}

class SetTransferredForm extends React.Component<Props, {}> {

  public render() {
    const {form} = this.props;
    return (
      <Form>
        <DatePickerFormItem
          form={form}
          fieldId={FIELD_PAID_DATE}
          label={locales.state_transferred}
          initialValue={moment()}
          required={true}
          showTime={false}
          format={MOMENT_DATE_FORMAT}
        />
        <SubmitCancelFormItem onSubmit={this.onFormSubmit} onCancel={this.onFormCancel}/>
      </Form>
    );
  }

  private onFormCancel = () => {
    this.props.form.resetFields();
    this.props.onFormCancel();
  };

  private onFormSubmit = () => {
    const {form, onFormSubmit} = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onFormSubmit(values[FIELD_PAID_DATE]);
      }
    });
  };
}

export default Form.create<Props>()(SetTransferredForm);



// WEBPACK FOOTER //
// ./src/incoming-invoices/SetTransferredForm.tsx